import { useEffect, useRef, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
const SWIPE_CLOSE_THRESHOLD = 70;
export const useSwipeDown = ({ onClose, isMobile, isOpen, scroll, enableSwipeToClose = true }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [delta, setDelta] = useState(0);
    const [swipeFlag, setSwipeFlag] = useState(onClose && isMobile);
    const isSwipeEnabled = Boolean(enableSwipeToClose && isMobile && isOpen && onClose);
    const paperRef = useRef(null);
    const swipeBlockRef = useRef(null);
    const swipeFxRef = useRef(null);
    const contentRef = useRef(null);
    const swipeableConfig = {
        delta: 30,
        preventScrollOnSwipe: true,
        trackTouch: true,
        trackMouse: true,
        rotationAngle: 0,
        swipeDuration: Infinity,
        touchEventOptions: { passive: false } // options for touch listeners (*See Details*)
    };
    const setInitialStyles = () => {
        if (paperRef.current) {
            paperRef.current.style.transform = 'translateY(0)';
        }
        if (swipeFxRef.current) {
            swipeFxRef.current.style.transform = 'scale(1)';
        }
        setDelta(0);
    };
    const handleSetSwipeFlag = (target) => {
        var _a;
        const startedInsideContent = !!target && !!((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.contains(target));
        setSwipeFlag(!(startedInsideContent && isScrolled && onClose));
    };
    const handlers = useSwipeable(Object.assign(Object.assign({}, swipeableConfig), { onSwipedDown: () => {
            if (!swipeFlag || !isSwipeEnabled) {
                return;
            }
            if (delta > SWIPE_CLOSE_THRESHOLD) {
                onClose();
            }
        }, onSwipeStart: data => {
            if (!isSwipeEnabled) {
                return;
            }
            handleSetSwipeFlag(data.event.target);
        }, onTouchStartOrOnMouseDown: data => {
            if (!isSwipeEnabled) {
                return;
            }
            handleSetSwipeFlag(data.event.target);
        }, onTouchEndOrOnMouseUp: () => {
            if (!swipeFlag || !isSwipeEnabled) {
                return;
            }
            if (delta < SWIPE_CLOSE_THRESHOLD) {
                setInitialStyles();
            }
            setSwipeFlag(!(isScrolled && onClose));
        }, onSwiping: data => {
            if (!swipeFlag || !isSwipeEnabled) {
                return;
            }
            const deltaY = data.deltaY;
            setDelta(deltaY);
            if (deltaY > 0) {
                if (paperRef.current) {
                    paperRef.current.style.transform = `translateY(${deltaY}px)`;
                }
                if (swipeFxRef.current) {
                    swipeFxRef.current.style.transform =
                        deltaY <= SWIPE_CLOSE_THRESHOLD ? `scale(${1 - deltaY / SWIPE_CLOSE_THRESHOLD})` : 'scale(0)';
                }
            }
        } }));
    useEffect(() => {
        var _a;
        if (!isSwipeEnabled) {
            return undefined;
        }
        const onScroll = (e) => {
            setIsScrolled(e.target.scrollTop > 0);
        };
        if (contentRef.current && isOpen && onClose) {
            setInitialStyles();
            (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', onScroll);
            handlers.ref(scroll === 'body' ? swipeBlockRef.current : paperRef.current);
        }
        return () => {
            var _a;
            (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', onScroll);
            handlers.ref(null);
        };
    }, [isOpen, isMobile, onClose, scroll]);
    return { handlers, contentRef, swipeBlockRef, swipeFxRef, paperRef };
};
